import { PaymentStatusEnum, TreatmentStatusEnum } from '@api/GoodocAPI';
import {
  useFocusable,
  UseFocusableConfig
} from '@noriginmedia/norigin-spatial-navigation';
import { generateTreatmentHistoryItemsFocusKey } from '@pages/TreatmentHistory/focusKey';
import { FC } from 'react';

import * as styles from './styles';

interface TreatmentListItemProps extends UseFocusableConfig {
  index: number;
  status: TreatmentStatusEnum;
  paymentStatus: PaymentStatusEnum;
  patientName: string;
  departmentName: string;
  doctorName?: string;
  hospitalName?: string;
  treatmentEndedAt: string;
  isPrescriptionExists?: boolean;
}

const TreatmentListItem: FC<TreatmentListItemProps> = (props) => {
  const {
    index,
    status,
    paymentStatus,
    patientName,
    departmentName,
    doctorName,
    hospitalName,
    treatmentEndedAt,
    isPrescriptionExists,
    onEnterPress,
    onFocus
  } = props;

  const { ref, focused } = useFocusable({
    focusKey: generateTreatmentHistoryItemsFocusKey(index),
    onEnterPress,
    onFocus
  });

  const treatmentStatusButton = () => {
    switch (status) {
      case TreatmentStatusEnum.Completion:
        return <div css={styles.button}>진료완료</div>;
      case TreatmentStatusEnum.Orderprescription: {
        if (
          paymentStatus === PaymentStatusEnum.Requested ||
          paymentStatus === PaymentStatusEnum.PaymentFailed ||
          paymentStatus === PaymentStatusEnum.RefundCompleted
        )
          return <div css={[styles.button, styles.emphasis]}>수납대기</div>;
        if (!isPrescriptionExists) return;
        return <div css={styles.button}>처방전 발급</div>;
      }
      default:
        return;
    }
  };

  return (
    <div ref={ref} css={[styles.container, focused && styles.focusedContainer]}>
      <div css={styles.leftContainer}>
        <div css={styles.patientName}>{patientName}</div>
        <div css={styles.departmentName}>{departmentName}</div>
        <div css={styles.doctorContainer}>
          <div css={styles.doctorName}>{doctorName}</div>
          <div css={styles.hospitalName}>{hospitalName}</div>
        </div>
      </div>
      <div css={styles.rightContainer}>
        <div css={styles.treatmentEndedAt}>{treatmentEndedAt}</div>
        <div css={styles.prescriptionContainer}>{treatmentStatusButton()}</div>
      </div>
    </div>
  );
};

export default TreatmentListItem;
